export default "__VITE_ASSET__COeiK6yg__"